<section>
    <div class="title">
        <span>My</span>
        <img src="https://res.cloudinary.com/bleachr/image/upload/v1636039483/TennisONE/DEV/one_tennis_banner_logo.png" alt="" />
        <span>Score</span>
    </div>
    @if (loggedIn) {
        @if (match_data) {}
    } @else {
        <div class="not-logged-in">
            <img src="https://res.cloudinary.com/bleachr/image/upload/v1633622559/TennisONE/T1%20Icons/profile.png" alt="" />
            @if (!isFollowing) {
                <div class="sign-in-prompt">Sign in to see your followed players here</div>
            }
            @if (isFollowing) {
                <div class="sign-in-prompt">Follow a player now to view matches</div>
            }
        </div>
    }
</section>
